import { Injectable } from '@angular/core';
import { NodeType } from '@modules/campaigns/Domain/Enums/NodeType';
import { NodeInspectorRegistry } from '@shared/state/node-inspector-registry.service';
import { ExperimentInspectorComponent } from '@shared/components/joint-js/components/inspectors/experiment-inspector/experiment-inspector.component';
import { OfferPaymentAgreementInspectorComponent } from '@shared/components/joint-js/components/inspectors/offer-payment-agreement-inspector/offer-payment-agreement-inspector.component';
import { OfferPartialPaymentInspectorComponent } from '@shared/components/joint-js/components/inspectors/offer-partial-payment-inspector/offer-partial-payment-inspector.component';
import { EmailInspectorComponent } from '@shared/components/joint-js/components/inspectors/email-inspector/email-inspector.component';
import { SmsInspectorComponent } from '@shared/components/joint-js/components/inspectors/sms-inspector/sms-inspector.component';
import { ConditionalInspectorComponent } from '@shared/components/joint-js/components/inspectors/conditional-inspector/conditional-inspector.component';
import { AssignCampaignInspectorComponent } from '@shared/components/joint-js/components/inspectors/assign-campaign-inspector/assign-campaign-inspector.component';
import { SegmentInspectorComponent } from '@shared/components/joint-js/components/inspectors/segment-inspector/segment-inspector.component';
import { CreateMascComponent } from '@shared/components/joint-js/components/inspectors/create-masc-inspector/create-masc-inspector.component';

@Injectable({ providedIn: 'root' })
export class NodeInspectorRegistrar {
  constructor(registry: NodeInspectorRegistry) {
    registry.register(NodeType.Experiment, ExperimentInspectorComponent);
    registry.register(NodeType.OfferPaymentAgreement, OfferPaymentAgreementInspectorComponent);
    registry.register(NodeType.OfferPartialPayment, OfferPartialPaymentInspectorComponent);
    registry.register(NodeType.SendSMS, SmsInspectorComponent);
    registry.register(NodeType.Conditional, ConditionalInspectorComponent);
    registry.register(NodeType.SendEmail, EmailInspectorComponent);
    registry.register(NodeType.AssignCampaign, AssignCampaignInspectorComponent);
    registry.register(NodeType.ConditionalSegments, SegmentInspectorComponent);
    registry.register(NodeType.CreateMasc, CreateMascComponent);

    // register other node inspectors here:
    // registry.register(NodeType.Email, EmailInspectorComponent);
    // ...
  }
}
